export enum AccountType {

    /** Cash account. */
    CASH = 'CASH',

    /** Margin account. */
    MARGIN = 'MARGIN'

}

export const ACCOUNT_TYPE_LABEL_MAP: Record<AccountType, string> = {
    [AccountType.CASH]:   'enums.account-type.cash',
    [AccountType.MARGIN]: 'enums.account-type.margin'
};
